import { MemberStripeStatus } from 'src/modules/invoice/models/memberStripeStatus';
import { MemberStripeStatusSearchFilter } from 'src/modules/invoice/models/memberStripeStatusSearchFilter';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'MemberStripeStatus';

export const getAllMemberStripeStatus = (filter: MemberStripeStatusSearchFilter) => {
  return AxiosInstance.get<PagedResult<MemberStripeStatus>>(`${controller}`, { params: filter });
};

export const getMemberStripeStatusById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<MemberStripeStatus>(endpoint);
};

export const createMemberStripeStatus = (data: MemberStripeStatus) => {
  return AxiosInstance.post<MemberStripeStatus>(controller, data);
};

export const updateMemberStripeStatus = (data: MemberStripeStatus) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<MemberStripeStatus>(endpoint, data);
};

export const deleteMemberStripeStatus = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};
